export enum HotelLocationType {
  Airport = "AIRPORT",
  City = "CITY",
  Country = "COUNTRY",
  Hotel = "HOTEL",
  Region = "REGION",
}
